module.exports = __webpack_public_path__ + "static/media/man_han_ris_ass.250d87cc.png";